import React from "react";

function AllocatePointsSuccessIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="39"
      fill="none"
      viewBox="0 0 35 39"
    >
      <path
        stroke="var(--color-highlight)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M24.058 1.968c-.723-.759-2.72-.034-4.46 1.616-1.736 1.649-2.559 3.597-1.836 4.355M23.74 4.453c.618-1.052.773-2.01.317-2.485M17.768 7.94c.723.758 2.72.033 4.46-1.617.14-.133.273-.265.4-.404"
      ></path>
      <path
        stroke="var(--color-highlight)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M17.768 7.94l1.685 1.76c.723.758 2.72.033 4.46-1.617 1.736-1.65 2.559-3.597 1.836-4.355l-1.685-1.76M4.72 9.472c1.373-.99 4.31.756 6.568 3.888 2.258 3.137 2.976 6.474 1.602 7.464M4.61 13.849c-.79-2.002-.807-3.715.11-4.377M12.89 20.824c-1.374.984-4.31-.757-6.569-3.888-.022-.033-.044-.067-.072-.1"
      ></path>
      <path
        stroke="var(--color-highlight)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M12.89 20.823L9.697 23.12c-1.374.99-4.31-.756-6.568-3.887-2.253-3.137-2.97-6.474-1.602-7.464l3.192-2.297M15.324 32.61c-1.64-1.74.261-6.195 4.243-9.944 3.983-3.748 8.543-5.378 10.184-3.631M19.502 32.866c-1.83.646-3.365.612-4.177-.255M29.758 19.029c1.64 1.74-.262 6.195-4.244 9.944-.85.8-1.73 1.507-2.603 2.102"
      ></path>
      <path
        stroke="var(--color-highlight)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M29.756 19.029l3.821 4.06c1.641 1.74-.261 6.196-4.243 9.944-3.983 3.749-8.543 5.378-10.184 3.632l-3.82-4.06"
      ></path>
    </svg>
  );
}

export default AllocatePointsSuccessIcon;
